<template>
  <ion-page>
    <master-layout pageTitle="افزودن آدرس جدید">
      <AjaxForm route="Address/Add" :callback="addResponse">
        <ion-card>
          <ion-card-content>
            <div>
              <label>عنوان</label>
              <input type="text" name="title" class="form-control">
            </div>
            <div>
              <label>نام تحویل گیرنده</label>
              <input type="text" name="fullname" class="form-control">
            </div>
            <div>
              <label>تلفن تماس</label>
              <input type="text" name="phone" class="form-control">
            </div>
            <div>
              <label>آدرس</label>
              <textarea name="address" class="form-control"></textarea>
            </div>
            <div>
              <label>استان</label>
              <select autocomplete="off"
                      class="form-control"
                      @change="getCities($event)" name="state_id">
                <option value="0" disabled selected>لطفا استان مورد نظر را انتخاب نمایید</option>
                <option :key="state._id" v-for="state in states" :value="state._id">{{ state.title }}</option>
              </select>
            </div>
            <div class="mb-2">
              <label>شهر</label>
              <div class="city_div">
                <select name="city_id" data-title="استان را انتخاب کنید" class="form-control">
                  <option :key="city._id" v-for="city in cities" :value="city._id">{{ city.title }}</option>
                </select>
              </div>
            </div>
            <div>
              <label>کدپستی</label>
              <input type="tel" name="postal_code" class="form-control">
            </div>
            <div class="mt-2">
              <input value="1" autocomplete="off" type="checkbox"
                     class="custom-control-input" id="customCheck"
                     name="default">
              <label class="custom-control-label" for="customCheck">&nbsp;آدرس پیش فرض باشد</label>
            </div>
            <ion-button type="submit" color="success" expand="full">افزودن آدرس</ion-button>
          </ion-card-content>
        </ion-card>
      </AjaxForm>
    </master-layout>
  </ion-page>
</template>

<script>
import {mapActions} from "vuex";
import {IonPage,IonCard,IonCardContent} from '@ionic/vue';
import AjaxForm from "@/components/AjaxForm";
import {showSystemNoti} from "@/shared/helper";

// import {getFormData} from '@/shared/helper'

export default {
  name: "AddWarehouse",
  components: {
    IonPage,IonCard,IonCardContent,AjaxForm
  },
  data()
  {
    return {
      jobs : [],
      states: [],
      cities: [{_id: 0, title: 'ابتدا استان را انتخاب نمایید'}]
    }
  },
  async mounted()
  {
    this.states = await this.getStates();
  },
  methods: {
    ...mapActions("app", {
      getStates: 'getStates',
      apiGetCities: 'getCities',
    }),
    async getCities(event)
    {
      const result = await this.apiGetCities(event.target.value);
      if (result)
      {
        this.cities = result.cities;
      }
    },
    addResponse(data)
    {
      const self = this;
      if (data.ok)
      {
        showSystemNoti('success',data.message,function (){
          self.$router.push({path : '/Address/List'})
        })
      }
      else
        showSystemNoti('danger',data.error);
    }
  }
}

</script>

<style scoped>
.mt-2
{
  margin-top: 10px;
}
</style>